import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../services/_services';
// import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
// import { DataTableDirective } from 'angular-datatables';
// import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-ai-subscription-link',
  templateUrl: './ai-subscription-link.component.html',
  styleUrls: ['./ai-subscription-link.component.css']
})
export class AiSubscriptionLink implements OnInit {

  public aiSiteList           : any = AppSettings.aiSiteList;
  public aiSubscriptionLink: any = { site_link: null, email: '', plan_id: null };
  public plans: any = [];
  public url:string = '';

  
  constructor(
    private helperService: HelperService,
    // private agentsService: Agents,
    // private appSettings: AppSettings,
    // private authenticationService: AuthenticationService,
    // private formBuilder: FormBuilder,
    // private cdr: ChangeDetectorRef
  ) {



  }

  ngOnInit() {
    
  }

  ngAfterViewInit() {
  }

  ngOnDestroy(): void {
   
  }

  rerender(): void {
  
  }

  clearFilters() {
    this.aiSubscriptionLink = { site_link: null, email: '', plan_id: null };
    this.plans = [];
    this.url='';
    this.rerender();
  }

  get_plans(){
    this.plans = [];
    let site_link = this.aiSubscriptionLink.site_link

    let url = AppSettings.API_ENDPOINT + "ai-subscriptions/get-user-and-plans/"+site_link;
    // console.log("data", data);
    this.helperService.httpGetRequests(url).then(resp => {
      // Hide Status Loader
      // this.aiSubscriptionLink.data[this.lead_Index].loading = false;

      if (typeof resp !== "undefined" && resp.status == "200") {
        // Clear existing plans if necessary
        
    
        // Iterate over the plans in the response
        resp.plans.forEach(plan => {
          this.plans.push({
            label: plan.duration + 'ly-' + plan.unit_amount,
            value: plan.id
          });
        });

        console.log('this.plans',this.plans)
      }

      if (typeof resp != "undefined" && resp.status == "ERROR") {
        Swal.fire('', resp.message, 'error');
      }
    }).catch(err => {

      Swal.fire('', err.error.message, 'error');
    });
  }

  generate_subscription_link() {
    // Hide Modal
    // Hide Modal


    // Show Status Loader

    let url = AppSettings.API_ENDPOINT + "ai-subscriptions/sales-checkout-session";
    let data = this.aiSubscriptionLink;
    // console.log("data", data);
    this.helperService.httpPostRequests(url, data).then(resp => {
      // Hide Status Loader


      if (typeof resp != "undefined" && resp.status == "200") {
        this.url = resp.checkout_session.url;
        $('#content-text').text(this.url);
      }

      if (typeof resp != "undefined" && resp.status == "400") {
        Swal.fire('', resp.message, 'error');
      }
    }).catch(err => {
      // Hide Status Loader


      Swal.fire('', err.error.message, 'error');
    });
  }

  copyText() {
    let text = this.url;
    navigator.clipboard.writeText(text).then(() => {
      console.log('Text copied to clipboard');
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }


}
